import { useContext, useState } from "react";
import jwtDecode from "jwt-decode";
import * as Device from "expo-device";

import UserContext from "../context/userContext";
import cache from "../utility/cache";
import usersApi from "../api/users";
import useApi from "./useApi";
import authApi from "../api/auth";
import config from "../config/config";

const useUser = () => {
    const { user, setUser } = useContext(UserContext);
    const setDeviceDetailsApi = useApi(usersApi.setDeviceDetails);
    const getAuthTokenApi = useApi(authApi.getToken);

    const logIn = (authToken) => {
        const user = jwtDecode(authToken);
        setUser(user);
        cache.storeToken(authToken);
    };

    const logOut = () => {
        setUser({ type: "customer" });
        cache.removeToken();
    };

    const setDeviceDetails = async () => {
        await setDeviceDetailsApi.request(config.versionNo, Device.brand + " " + Device.modelName);
    };

    const getToken = async (userID) => {
        const response = await getAuthTokenApi.request(userID);
        if (!response.ok) {
            if (response.status == 403) {
                logOut();
            }
            return;
        }

        logIn(response.data);
    };

    return { user, setUser, setDeviceDetails, logIn, logOut, getToken };
};
export default useUser;
